const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getCompromisedReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'COMPROMISED_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'COMPROMISED_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'COMPROMISED_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'COMPROMISED_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getCompromisedReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getCompromisedReport.js